// import GoogleAutoComplete from "components/GoogleAutoComplete"
import SinglePicker from "components/Pickers/SinglePicker"
import cn from "classnames"
import ConditionalView from "components/ConditionalView"
import useUserStore from "stores/user"
import { withLDConsumer } from "launchdarkly-react-client-sdk"

const TerminalPicker = (props: any) => {
  const { limitTerminalsBySiteDistance } = props.flags
  const tenantId = useUserStore((s) => s.tenant?.id)
  const shouldFilterByLocation =
    tenantId === 24 &&
    limitTerminalsBySiteDistance &&
    (props.location?.id || props.location)
  const locationParam = shouldFilterByLocation
    ? `?customer_location=${props.location?.id || props.location}`
    : ""

  return (
    <div className={cn("flex-c-box", "w-full", props.className)}>
      <ConditionalView condition={!props.noLabel && props.label}>
        <span className="mb-[8px] font-bold text-primary-text">
          {props.label}
        </span>
      </ConditionalView>

      <SinglePicker
        pageSize={10000}
        isDisabled={props.displayOnly}
        endpoint={`terminals${locationParam}`}
        flush={props.flush}
        errorText={props.errorText}
        placeholder={props.placeholder ?? "Choose Terminal"}
        labelKey="name"
        isClearable={props.isClearable}
        selected={props.terminal?.id ?? props.terminal ?? props.selected}
        styles={props?.styles}
        onSelect={(e: any) => {
          props.onChange({
            terminal: e?.value,
            terminal_label: e?.label,
            loading_number_id: null,
            default_supplier: null,
            supplier: null,
            loading_number: null,
            wholesaler: null,
            description: null,
            preferred_source: {
              terminal: e?.value,
              terminal_label: e?.label,
            },
          })
        }}
      />
    </div>
  )
}

export default withLDConsumer()(TerminalPicker)
